import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Route, Switch } from "react-router-dom";
import { useHistory } from "./core/utils";

import { Login } from "./views/Login/Login";
import { Home } from "./views/Home";
import { NotFound } from "./views/NotFound";
import { Products, Product } from "./views/Prodcuts";
import { Sites } from "./views/Sites";
import { ExcelSummary } from "./views/ExcelSummary";
import { Drivers } from "./views/Drivers/Drivers";
import { Employees } from "./views/Employees/Employees";
import { ProductCityStock } from "./views/ProductCityStock/ProductCityStock";
import { BuyProductReport } from "./views/BuyProductReport/BuyProductReport";
import { ServiceCenterStock } from "./views/ServiceCenterStock/ServiceCenterStock";
import { CarsServiceReport } from "./views/CarsServiceReport/CarsServiceReport";
import { CreditManagement } from "./views/CreditManagment/CreditManagement";
import { MessagesReport } from "./views/MessagesReport/MessagesReport";
import { Notifications } from "./views/Notifications/Notifications";
import { Cars } from "./views/Cars/Cars";
import { API } from "./core/api";
import { Actions } from "./store/actions";
import { Layout } from "./components/Layout/Layout";

export const Main = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const store = useSelector((state) => state?.Store);

  useEffect(() => {
    if (!store.user?.is_login) {
      dispatch(
        Actions.LoginUser({
          first_name: "Faisal",
          last_name: "Al-Haddad",
          username: "099999",
          token: "test",
          user_type: "company_owner",
        })
      );
    }
  }, [store, history]);

  const provinces = [
    {
      id: 1,
      name: "Riyadh Province",
    },
    {
      id: 2,
      name: "Eastern Province",
    },
    {
      id: 3,
      name: "	Hail Province",
    },
  ];

  const cities = [
    {
      id: 101,
      name: "Riyadh",
    },
    {
      id: 102,
      name: "Al-Kharj",
    },
    {
      id: 103,
      name: "Dawadmi",
    },
    {
      id: 104,
      name: "Al-Majma'ah",
    },
    {
      id: 105,
      name: "Al-Quwayiyah",
    },
    {
      id: 201,
      name: "Dammam",
    },
    {
      id: 202,
      name: "Al-Khobar",
    },
    {
      id: 203,
      name: "Dhahran",
    },
    {
      id: 204,
      name: "Al-Jubail",
    },
    {
      id: 205,
      name: "Ras Tanura",
    },
  ];

  useEffect(() => {
    dispatch(Actions.GetProvinces(provinces));
  }, []);

  // useEffect(() => {
  //   if (store.user?.is_login && store.user?.token) {
  //     API.get.provinces().then((response) => {
  //       if (response.success) {
  //         dispatch(Actions.GetProvinces(response.data));
  //       }
  //     });
  //   }
  //   // eslint-disable-next-line
  // }, [store.user?.is_login, store.user?.token])

  return (
    <Layout>
      <Switch>
        <Route path="/" exact component={Home} />
        <Route path="/login/" exact component={Login} />
        <Route path="/products/" exact component={Products} />
        <Route path="/products/:id/" exact component={Product} />
        <Route path="/sites/" exact component={Sites} />
        <Route path="/drivers/" exact component={Drivers} />
        <Route path="/credit/" exact component={CreditManagement} />
        <Route path="/messages-report/" exact component={MessagesReport} />
        <Route path="/cars/" exact component={Cars} />
        <Route path="/cities-and-users/" exact component={Employees} />
        <Route path="/buy-product-report/" exact component={BuyProductReport} />
        <Route path="/notifications/" exact component={Notifications} />
        <Route
          path="/cars-service-report/"
          exact
          component={CarsServiceReport}
        />
        <Route path="/product-city-stock/" exact component={ProductCityStock} />
        <Route
          path="/service-center-stock/"
          exact
          component={ServiceCenterStock}
        />
        <Route path="/excel-summary/" exact component={ExcelSummary} />
        <Route path="*" component={NotFound} />
      </Switch>
    </Layout>
  );
};
